import { REFRESH_TOKEN_SUCCESS, TokenActionType } from '@tshio/redux-api-auth-middleware';
import { Action, Dispatch, Middleware } from 'redux';
import { State } from 'store/state/state.types';
import { AUTH_COOKIE, AUTH_REFRESH_COOKIE, REFRESH_TOKEN_ERROR } from 'store/store';
import { setSecureCookie } from 'utils';

export const refreshTokenMiddleware: Middleware<{}, State, Dispatch> = store => (next: Dispatch<Action>) => (
  action: any,
) => {
  if (action.type === REFRESH_TOKEN_SUCCESS) {
    const payload = action.payload as TokenActionType;

    if (payload.access_token && payload.refresh_token) {
      setSecureCookie(AUTH_COOKIE, payload.access_token);
      setSecureCookie(AUTH_REFRESH_COOKIE, payload.refresh_token);
    }
  }

  if (action.type === REFRESH_TOKEN_ERROR) {
    throw new Error();
  }

  return next(action);
};
